/// Deployment
// export const redirectUri = "http://localhost:3000/";
// export const SceneEnvPath = "/Assets/venice_sunset_1k.hdr";
// export const mavImg = "/Assets/mav.png";
// export const phoImg = "/Assets/pho.png";
// export const phoWBImg = "/Assets/pho-wb.png";
// export const iconsPath = "/Assets/Phoenix_2_0/thumbnails/whiteRed/";

/// Live website
export const redirectUri = "https://projecthermes.xyz/";
export const SceneEnvPath =
  "https://projecthermes.xyz/Assets/venice_sunset_1k.hdr";
export const mavImg = "https://projecthermes.xyz/Assets/mav.png";
export const phoImg = "https://projecthermes.xyz/Assets/pho.png";
export const phoWBImg = "https://projecthermes.xyz/Assets/pho-wb.png";
export const iconsPath =
  "https://projecthermes.xyz/Assets/Phoenix_2_0/thumbnails/whiteRed/";
